import React from 'react';
import "./Header.css";

function Header() {
  return (
    <div className='header'>
    <h3 className='white-color'>Coder</h3>
      <h3 className='white-bg'>Stopwatch</h3>
    </div>
    
  )
}

export default Header